import { Crosshair } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-[#5A2A24] bg-[#1E070A]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <div className="flex items-center gap-4 mb-4">
            <img src="https://customer-assets-39nsmqrw.emergentagent.net/job_gunbri-broker/artifacts/egembtay_image.png" alt="Shooter Bazaar" className="h-24 w-24 object-contain border border-[#5A2A24]" />
            <span className="font-display text-2xl">SHOOTER <span className="text-[#C0894F]">BAZAAR</span></span>
          </div>
          <p className="text-[#C7A98F] max-w-md">A curated brokerage for the discerning collector. Every transaction routed through licensed FFL dealers. Compliance is not optional.</p>
        </div>
        <div className="md:col-span-3">
          <div className="mono-label mb-4">Navigate</div>
          <ul className="space-y-3">
            <li><Link to="/marketplace" className="hover:text-[#C0894F] transition-colors">Marketplace</Link></li>
            <li><Link to="/dashboard" className="hover:text-[#C0894F] transition-colors">Dashboard</Link></li>
            <li><Link to="/auth" className="hover:text-[#C0894F] transition-colors">Account</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="mono-label mb-4">Legal</div>
          <p className="text-[#8C6552] text-sm leading-relaxed">All firearm transfers comply with federal, state, and local law. Buyers must pass a background check via a licensed FFL. 18+ / 21+ where applicable.</p>
        </div>
      </div>
      <div className="border-t border-[#5A2A24] py-6 text-center mono-label">© {new Date().getFullYear()} Shooter Bazaar — Fictional demo. Not a real dealer.</div>
    </footer>
  );
}
